import { AiPanelIconToken, AiPanelTone } from '@tools/shared';
import { IconType, IconVariant, semanticTheme } from '@tools/ui/dime';

const ICON_TOKEN_MAP: Record<AiPanelIconToken, IconType> = {
  success: IconType.Approved,
  warning: IconType.Warning,
  critical: IconType.Warning,
  remove: IconType.Declined,
  company: IconType.Company,
  email: IconType.Email,
  address: IconType.Address,
  phone: IconType.Phone,
  website: IconType.Web,
  shield: IconType.ShieldCheck,
  copy: IconType.Copy,
  link: IconType.Link,
  externalLink: IconType.ExternalLink
};

const TONE_COLOR_MAP: Record<AiPanelTone, string | undefined> = {
  default: undefined,
  success: semanticTheme.dime.colors.fill.successPrimary,
  warning: semanticTheme.dime.colors.fill.warningPrimary,
  critical: semanticTheme.dime.colors.fill.criticalPrimary,
  secondary: semanticTheme.dime.colors.text.secondary,
  link: semanticTheme.dime.colors.link.primary,
  emailAge: semanticTheme.dime.colors.text.secondary
};

const VARIANT_MAP: Record<AiPanelIconToken, IconVariant> = {
  success: IconVariant.Solid,
  warning: IconVariant.Solid,
  critical: IconVariant.Solid,
  remove: IconVariant.Outline,
  company: IconVariant.Outline,
  email: IconVariant.Outline,
  address: IconVariant.Outline,
  phone: IconVariant.Outline,
  website: IconVariant.Outline,
  shield: IconVariant.Outline,
  copy: IconVariant.Outline,
  link: IconVariant.Outline,
  externalLink: IconVariant.Outline
};

export const getIconType = (token?: AiPanelIconToken): IconType | undefined =>
  token ? ICON_TOKEN_MAP[token] : undefined;

export const getIconVariant = (
  token?: AiPanelIconToken
): IconVariant | undefined => (token ? VARIANT_MAP[token] : undefined);

export const getToneColor = (tone?: AiPanelTone): string | undefined =>
  tone ? TONE_COLOR_MAP[tone] : undefined;
